<template>
  <div class="companyOutlookBox">
    <ul>
        <li v-for="(item,index) in indexSearchInfo" :key='index'>
            <!--[公司展望 start]-->
            <div class="box">
                <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
                <div :id="'companyOutlook'+index" class="main1" style="width:100%; height:100%;"></div>
            </div>
            <!--[公司展望 end]-->
        </li>
    </ul>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import ssUtil from '@/utils/SStorage'

  export default {
    name: 'companyOutlookBox',
    data() {
      return {
          companyOutlook:[],
      }
    },
    computed: {...mapState(['indexSearchInfo','colorArr'])},
    created(){},
    methods: {
        //获取公司展望信息
        getCompanyOutlook(){
            let that = this,elList=[],myChart = [];
            this.indexSearchInfo.forEach(function( item,index ){
                let data = [],links = [];
                let color = ['#82778d', '#82778d'];
                data.push({
                    value : item.securityName,
                    name : item.securityName,
                    symbolSize: 50,
                    draggable: true,
                    typeFlag : 'company',
                    securityName : item.securityName,
                    securityCode : item.securityCode,
                    coCode : item.coCode,
                    itemStyle: {
                        normal: {
                            color: that.colorArr[0]
                        }
                    }
                }),
                item.prospectList.forEach( function( it ){
                    data.push({
                        value : it.driveName,
                        name : it.driveName,
                        coCode : item.coCode,
                        typeFlag : 'company',
                        securityName : item.securityName,
                        securityCode : item.securityCode,
                        symbolSize : 30,
                        itemStyle: {
                            normal: {
                                // color: that.colorArr[it.driveType]
                                color: color[index]
                            }
                        }
                    }),

                    links.push({
                        source: item.securityName,
                        target: it.driveName
                    })
                })
                var option = {
                    title: {text: ''},
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    animation: false,
                    animationEasingUpdate: 'quinticInOut',
                    series: [
                    {
                        type: 'graph',
                        layout: 'force',
                        symbol: 'circle',
                        symbolSize: 30,
                        draggable: true,
                        roam: false,
                        label: {
                            normal: {
                                show: true,
                                fontSize: 16,
                                fontWeight: 500,
                                position:'top',
                                color:'#333',
                            },
                        },
                        force: {
                            // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                            // 力引导布局的结果有良好的对称性和局部聚合性，也比较美观。
                            repulsion: 845, // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                            edgeLength: 155 // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                            // 这个距离也会受 repulsion。支持设置成数组表达边长的范围，此时不同大小的值会线性映射到不同的长度。值越小则长度越长。如下示例:
                            // 值最大的边长度会趋向于 10，值最小的边长度会趋向于 50      edgeLength: [10, 50]
                        },
                        edgeSymbol: ['circle', 'arrow'],
                        edgeSymbolSize: [4, 10],
                        cursor: 'pointer',
                        data: data,
                        tooltip: {
                            formatter: '{b}',
                            backgroundColor: 'rgba(50,50,50,0.8)'
                        },
                        links: links,
                        lineStyle: {
                            normal: {
                                opacity: 0.5,
                                width: 1,
                                curveness: 0
                            }
                        }
                    }
                    ]
                };
                that.companyOutlook.push(option)
            })
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                elList = document.querySelectorAll('.companyOutlookBox>ul>li')
                for(var i=0;i< elList.length;i++ ){
                    myChart.push( that.$echarts.init( document.getElementById('companyOutlook'+i) ) );
                }
                for(var i=0;i< elList.length;i++ ){
                    //   指定图表的配置项和数据
                    myChart[i].setOption(that.companyOutlook[i]);
                    myChart[i].on('click', function (param) {
                          let params = {
                              type: 'company',
                              coCode:param.data.coCode,
                              securityCode:param.data.securityCode,
                              name:param.data.securityName
                          }
                          that.$router.push({name:'productInfo',params:params})
                    })
                }
            })
        }

    },
    mounted() {
        this.$nextTick(function(){
            this.getCompanyOutlook();
        })


    }
  }
</script>

<style lang="scss" src="../sass/companyOutlook.scss"></style>



// WEBPACK FOOTER //
// src/components/companyOutlook.vue